export default __webpack_public_path__ + "static/media/hht1_ani_07.e66710b8.png";